import { useNavigate, withRouteId } from '@melio/ar-domain';
import { forwardRef } from '@melio/platform-utils';
import { Route, Routes } from 'react-router-dom';

import { GuestPayorOnboardingActivity as _GuestPayorOnboardingActivity } from '../activities';
import { AuthResponse } from '../auth';
import { GuestPaymentFlow as _GuestPaymentFlow, PaymentFlowProps } from './GuestPayment.flow';

const GuestPaymentFlow = withRouteId(_GuestPaymentFlow, 'billId');
const GuestPayorOnboardingActivity = withRouteId(_GuestPayorOnboardingActivity, 'paymentRequestLink');

export type GuestPaymentWithAuthFlowProps = PaymentFlowProps & {
  onLoggedIn: (accessToken: string, refreshToken?: string | null) => Promise<unknown>;
};

const GuestPaymentFlowPaths = { payBill: 'pay/bill/:billId' } as const;
type GuestPaymentFlowPaths = (typeof GuestPaymentFlowPaths)[keyof typeof GuestPaymentFlowPaths];

export const GuestPaymentWithAuthFlow = forwardRef<GuestPaymentWithAuthFlowProps>(
  ({ onLoggedIn, onDone, ...props }, ref) => {
    const navigate = useNavigate<GuestPaymentFlowPaths>();
    const goToPaymentFlow = (billId: string) => navigate(GuestPaymentFlowPaths.payBill, { pathParams: { billId } });

    const onAuth = ({ accessToken, refreshToken, billId }: AuthResponse) =>
      onLoggedIn(accessToken, refreshToken)
        .then(() => goToPaymentFlow(billId))
        .catch(props.onError);

    return (
      <Routes>
        <Route path="pay/r/:id/*" element={<GuestPayorOnboardingActivity onDone={onAuth} />} />
        <Route path="pay/bill/:id/*" element={<GuestPaymentFlow onDone={onDone} {...props} ref={ref} />} />
      </Routes>
    );
  }
);
GuestPaymentWithAuthFlow.displayName = 'GuestPaymentWithAuthFlow';
